import React, { useEffect, useState, useContext, useRef } from "react";
import 'react-tabs/style/react-tabs.css';
import { Header } from "../../../components/Header";
import { Menu } from "../../../components/Menu";
import { MenuPage } from "../../../components/MenuPage";
import { StyledDefaultPage } from "../../../styled-components/StyledDefaultPage.style";
import { StyledForm } from "../../../styled-components/StyledForm.style";
import { DynamicInput } from "../../../components/DynamicInput";
import { DynamicSelect } from "../../../components/DynamicSelect";
import { StldRow } from "../../../styled-components/StldRow.style";
import { useForm } from 'react-hook-form';
import api from '../../../services/api';
import { MobileContext } from "../../../contexts/MobileContext";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { getClients } from '../../../services/clientes';
import * as moment from 'moment'
import DatePicker from 'react-datepicker';
import InputMask from "react-input-mask";
import Flex from '@react-css/flex';
import { StyledTablePage } from "../../../styled-components/StyledTablePage.style";
import XLSX from 'sheetjs-style';
import { getDisciplinas } from '../../../services/disciplinas';
import { getPeritos } from '../../../services/peritos';
import { StldColumn } from "../../../styled-components/StldColumn.style";
import { Multiselect } from 'multiselect-react-dropdown';
import { getStatus } from '../../../services/status';
import useUser from "../../../utils/useUser";
import { Link } from "react-router-dom";
import { IconRefresh } from "../../../svg";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { getUrlParams } from '../../../utils/getUrlParams'
import { CardWipContabil } from "../../../components/CardWipContabil";

const getLista = async (formValues) => {
    let list = null;
    let params = "";

    if (formValues.empresa == 0) {
        params += `&idEmpresa=1`;
    }
    else {
        params += `&idEmpresa=${formValues.empresa}`;
    }

    if (formValues.Sigla?.length > 0) {
        params += `&Sigla=${formValues.Sigla}`;
    }

    if (formValues.NumeroTimesheet?.length > 0) {
        params += `&NumeroTimesheet=${formValues.NumeroTimesheet}`;
    }

    if (formValues.idCliente > 0) {
        params += `&IdCliente=${formValues.idCliente}`;
    }

    if (formValues.idDisciplinas.length > 0) {
        formValues.idDisciplinas.forEach(disciplina => {
            params += `&IdDisciplinas=${disciplina}`;
        });
    }

    if (formValues.idPeritos.length > 0) {
        formValues.idPeritos.forEach(idPerito => {
            params += `&IdPeritos=${idPerito}`;
        });
    }

    if (formValues.status.length > 0) {
        formValues.status.forEach(idStatus => {
            if(idStatus != undefined)
            {
                params += `&status=${idStatus}`;
            }
        });
    }

    if (formValues.startDate) {
        params += `&PeriodoInicial=${moment(formValues.startDate).startOf('day').format('YYYY-MM-DD HH:mm')}`;
    }

    if (formValues.endDate) {
        params += `&PeriodoFinal=${moment(formValues.endDate).endOf('day').format('YYYY-MM-DD HH:mm')}`;
    }

    if (formValues.faturadoAte) {
        params += `&FaturadoAte=${moment(formValues.faturadoAte).endOf('day').format('YYYY-MM-DD HH:mm')}`;
    }

    try {
              
        const response = await api.get(`wip/contabil?${params}`);
       
        list = response.data;

        return list;
    } catch (err) {
        return list;
    }
}

export const WIPContabil = () => {
    const [ListaData, setListaData] = useState(null);
    const [TotaisData, setTotaisData] = useState(null);
    const { register, handleSubmit, reset, getValues } = useForm();
    const [clientList, setClientList] = useState([]);
    var [cliente, setCliente] = useState(null);
    var [idCliente, setIdCliente] = useState(null);
    const isMobile = useContext(MobileContext);
    const isDesktop = !isMobile;
    var [peritosList, setPeritosList] = useState([]);
    var [idPeritos, setPeritosId] = useState([]);
    const [disciplinaList, setDisciplinaList] = useState([]);
    var [idDisciplinas, setDisciplinasId] = useState([]);
    const [statusList, setStatusList] = useState([]);
    var [idStatus, setStatusId] = useState([]);
    var [isLoading, setisLoading] = useState(false);

    var [empresasUser, setEmpresasUser] = useState([]);
    var [idEmpresaIndexTab, setIdEmpresaIndexTab] = useState(0);
    const [empresa,setEmpresa] = useState(1);
    const [formData, setFormData] = useState(null);
    
    var [isLoadingPesquisa, setisLoadingPesquisa] = useState(true);
    const [WIPContabilData, setWIPContabilData] = useState(null);
    const [formvalues,setFormvalues] =useState([]);


    const formSubmit = async (data) => {       
        loadTable(data);
        setisLoadingPesquisa(true);
    }

    const loadTable = async (data) => {
        let formValues = {
            NumeroTimesheet: data?.NumeroTimesheet,
            Sigla: data?.Sigla,
            // Segurado: data?.Segurado,
            idCliente: idCliente,
            idPeritos: idPeritos,
            idDisciplinas: idDisciplinas,
            status: idStatus,
            startDate: startDate,
            endDate: endDate,
            faturadoAte:faturadoAte,
            idEmpresa: idEmpresaIndexTab,
            empresa : idEmpresaIndexTab
        };

        setEmpresa(1);        
        setisLoading(true);
        
        const result = await getLista(formValues);

      
        setListaData(result?.data?.list);    
        setTotaisData(result?.data?.totais);
        setisLoading(false)
    }


  

    const getCliente = (currentValue, value) => {
     
        if (value === null || value === "") {
            cliente = null;
            idCliente = null;
            setCliente(cliente);
            setIdCliente(idCliente);
            return;
        }

        var clienteResult = clientList.filter(function (o) {
            return o.idCliente == value;
        });
        cliente = clienteResult[0].cliente;
        idCliente = clienteResult[0].idCliente;
        setCliente(cliente);
        setIdCliente(idCliente);
    };


    useEffect(() => {
        const asyncFn = async () => {
            const clients = await getClients();
            if (!!clients) {
                setClientList(clients);            
            }
            const disciplinas = await getDisciplinas();
            if (!!disciplinas) {
                setDisciplinaList(disciplinas);
            }
            const status = await getStatus(13);
            if (!!status) {
                const statusWithSelectAll = [
                    { key: 'all', value: 'Selecionar Todos' },
                    ...status
                  ];
                setStatusList(statusWithSelectAll)
            }


            const peritos = await getPeritos();
            if (!!peritos) {
                const peritosFormatados = []
                peritos.map(perito => {
                    var item = {
                        "value": perito.idUsuario,
                        "id": perito.idUsuario,
                        "label": perito.nome
                    };
                    peritosFormatados.push(item);
                });
                setPeritosList(peritosFormatados);
            } 
        }
    
       asyncFn();

       

        checkIsMultEmpresaUser();
    }, [null, 0, 10]);

    const [startDate, setStartDate] = useState(null);
   
    
    const handleStartDateChange = (date) => {
        setStartDate(date);
    }

    const [endDate, setEndtDate] = useState(null);
    const handleEndDateChange = (date) => {
        setEndtDate(date);
    }


    const [faturadoAte, setfaturadoAte] = useState(null);


    const handlefaturadoAteChange = (date) => {
        setfaturadoAte(date);
    }

   
    const filtroEmpresa = async (currentValue, indexTab) => {       
        idEmpresaIndexTab = indexTab;
        setIdEmpresaIndexTab(idEmpresaIndexTab);

        const valuesForm =  getValues();
        let formValues = {
            NumeroTimesheet: valuesForm?.NumeroTimesheet,
            Sigla: valuesForm?.Sigla,
            // Segurado: valuesForm?.Segurado,
            idCliente: idCliente,
            idPeritos: idPeritos,
            idDisciplinas: idDisciplinas,
            status: idStatus,
            startDate: startDate,
            endDate: endDate,
            faturadoAte: faturadoAte,
            idEmpresa: currentValue,
            empresa: currentValue
            
        };
         
     
        setisLoading(true)
       
        const result = await getLista(formValues);
    
        setListaData(result?.data?.list);    
        setTotaisData(result?.data?.totais);   
        setisLoading(false)

    }
    const checkIsMultEmpresaUser = (value) => {
        
        const empresas = localStorage.getItem('empresasUsuario') ?
            JSON.parse(localStorage.getItem('empresasUsuario'))
            : [];
       
        if (empresas) {
            empresasUser = empresas;        
            setEmpresasUser(empresasUser);
        }

        if (empresasUser.length > 1) {
            idEmpresaIndexTab = 0;
            setIdEmpresaIndexTab(idEmpresaIndexTab);
        } else {
            switch (empresasUser[0]) {
                case '1':
                case 1:
                    setIdEmpresaIndexTab(0);
                    break;
                case '2':
                case 2:
                    setIdEmpresaIndexTab(1);
                    break;
                default:
                    setIdEmpresaIndexTab(2);
                    break;

            }
        }


    }


    const exportExcel = () => {
        if (!ListaData || ListaData.length === 0) {
            return;
        }
    
        const xlsxData = ListaData.map(meritocraciaData => ({
            Laudo: meritocraciaData.sigla,
            Horas: meritocraciaData.totalHorasFaturadas,
            ValorTotal: meritocraciaData.valorTotalFaturado,
            Cliente:  meritocraciaData.cliente
        }));
    
        const worksheet = XLSX.utils.json_to_sheet(xlsxData);
        const range = XLSX.utils.decode_range(worksheet["!ref"]); // Obtem o intervalo de células
        const colWidths = [];
    
        // Função para calcular largura das colunas automaticamente
        const autoFitColumns = (data, ws) => {
            const columnWidths = Object.keys(data[0]).map((key, colIndex) => {
                const maxContentWidth = Math.max(
                    key.length, // Largura do cabeçalho
                    ...data.map(row => (row[key] ? row[key].toString().length : 0)) // Largura do maior conteúdo
                );
                return { wch: maxContentWidth + 2 }; // Adiciona margem para evitar cortes
            });
    
            ws["!cols"] = columnWidths;
        };
    
        autoFitColumns(xlsxData, worksheet);
    
        // Estilizando cabeçalhos
        const fill = {
            font: { bold: true, color: { rgb: "FFFFFF" } },
            fill: { type: "pattern", patternType: "solid", fgColor: { rgb: "EE4B21" } },
            border: {
                top: { style: "thin", color: { rgb: "000000" } },
                bottom: { style: "thin", color: { rgb: "000000" } },
                left: { style: "thin", color: { rgb: "000000" } },
                right: { style: "thin", color: { rgb: "000000" } },
            },
            alignment: {
                horizontal: "center",
                vertical: "center", 
            },
        };

        // Itera sobre as colunas para ajustar a largura com base na segunda linha (linha de índice 1)
        for (let col = range.s.c; col <= range.e.c; col++) {
            const cellAddress = XLSX.utils.encode_cell({ r: 1, c: col }); // Segunda linha (índice 1)
            const cell = worksheet[cellAddress];
            
            if (cell && cell.v) {
                const textLength = cell.v.toString().length;
                colWidths[col] = { wch: textLength + 5 };
            } else {
                colWidths[col] = { wch: 10 };
            }

            worksheet[cellAddress].s = {
                font: {
                    bold: false,
                    color: { rgb: "000000" }, // Texto branco
                },
                fill: {
                    fgColor: { rgb: "FFFFFF" }, // Fundo azul
                },
                border: {
                    top: { style: "thin", color: { rgb: "000000" } },
                    bottom: { style: "thin", color: { rgb: "000000" } },
                    left: { style: "thin", color: { rgb: "000000" } },
                    right: { style: "thin", color: { rgb: "000000" } },
                },
                alignment: {
                    horizontal: "center",
                    vertical: "center", 
                },
            };
        }

        // Adiciona bordas ao restante das células
        for (let row = 1; row <= range.e.r; row++) {
            for (let col = 0; col <= range.e.c; col++) {
                const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
                if (!worksheet[cellAddress]) continue;
                let cellValue = worksheet[cellAddress].v;

                if (col >= 1 && col <= 2) {
                    if (typeof cellValue === 'string') {
                        cellValue = cellValue.replace(/\./g, '').replace(',', '.');
                    }

                    const numericValue = parseFloat(cellValue);

                    if (!isNaN(numericValue)) {
                        worksheet[cellAddress].v = numericValue; 
                        worksheet[cellAddress].t = 'n';          
                        worksheet[cellAddress].z = "#,##0.00";        
                    }                    
                }

                worksheet[cellAddress].s = {
                    border: {
                        top: { style: "thin", color: { rgb: "000000" } },
                        bottom: { style: "thin", color: { rgb: "000000" } },
                        left: { style: "thin", color: { rgb: "000000" } },
                        right: { style: "thin", color: { rgb: "000000" } },
                    },
                    alignment: {
                        horizontal: "center",
                        vertical: "center", 
                    },
                };
            }
        }
    
        ["A1", "B1", "C1", "D1"].forEach(cell => {
            if (worksheet[cell]) worksheet[cell].s = fill;
        });
    
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "ExportDB");
        const hoje = new Date().toLocaleDateString('pt-BR');
        XLSX.writeFile(workbook, `Contabil_${hoje}.xlsx`);
    };
    

    const onGetPerito = (currentValue, value) => {
        let peritosList = [];
        currentValue.map(a => { peritosList.push(a.id) });
        setPeritosId(peritosList);
    };

    const onRemovePerito = (currentValue, value) => {
        onGetPerito(currentValue)
    }

    const onGetDisciplina = (currentValue, value) => {
        let disciplinasList = [];
        currentValue.map(a => { disciplinasList.push(a.idDisciplina) });
        setDisciplinasId(disciplinasList);
    };

    const onRemoveDisciplina = (currentValue, value) => {
        onGetDisciplina(currentValue)
    }

    const onGetStatus = (currentValue, selectedItem) => {
        let idsList = [];
        if (selectedItem.key == 'all') {
            for (let i = 0; i < statusList.length; i++)
            {
                if (statusList[i].key != "all")
                {
                    idsList[i] = statusList[i].key;
                }
            }
            currentValue.filter(a => a.key != "all").map(a => { idsList.push(a.key) });
            setStatusId(idsList);
        }
        else
        {
            currentValue.filter(a => a.key != "all").map(a => { idsList.push(a.key) });
            setStatusId(idsList);
        }
    };
    
    const onRemoveStatus = (currentValue, removedItem) => {   
        if (removedItem.key == 'all') {
            setStatusId([]);
        }
        else
        {
            if(idStatus.length > 1) {
                let idsRemoves = [];
                for (let i = 0; i < idStatus.length; i++)
                {
                    idsRemoves[i] = idStatus[i];
                }

                if(idsRemoves.indexOf(removedItem.key))
                {
                    const index = idsRemoves.indexOf(removedItem.key);
                    idsRemoves.splice(index, 1);
                }
                
                setStatusId(idsRemoves);
            }
            else {
                setStatusId([]);
            }
        }
    };


    const refreshData = async () => {
        const valuesForm = getValues();
        let formValues = {
            NumeroTimesheet: valuesForm?.NumeroTimesheet,
            Sigla: valuesForm?.Sigla,
            // Segurado: valuesForm?.Segurado,
            idCliente: idCliente,
            idPeritos: idPeritos,
            idDisciplinas: idDisciplinas,
            status: idStatus,
            startDate: startDate,
            endDate: endDate,
            faturadoAte: faturadoAte,
            idEmpresa: idEmpresaIndexTab,
            empresa:idEmpresaIndexTab
            
        };

        loadTable(formValues);
    };


    return (
        <section>
            <main className="d-flex">
                {(() => {
                    if (isDesktop) {
                        return (
                            <Menu></Menu>
                        )
                    }
                    return null
                })()}
                <StyledDefaultPage>
                    <div className="w-100 d-flex justify-content-between align-items-center">
                        <div className="title-row">
                            <h5 className="title-row-header">WIP Contábil</h5>
                            <span title="Atualizar" className="cursorPointer" onClick={refreshData}><IconRefresh color={"#EE4B21"} /></span>
                        </div>
                    </div>
                     
                    <div className="card">
                        <StyledForm onSubmit={handleSubmit(formSubmit)}>
                            <div className='form-wrapper filter-container'>
                                <div className="form-group col-sm-12 col-md-3 col-lg-3">
                                    <DynamicInput type={'text'} placeholder={''} label={'Sigla'} name={'Sigla'} register={register} />
                                </div>
                                <div className="form-group col-sm-12 col-md-3 col-lg-3">
                                    <DynamicInput type={'text'} placeholder={''} label={'Nº Timesheet(Ex: TS01)'} name={'NumeroTimesheet'} register={register} />
                                </div>
                                <div className="form-group col-sm-12 col-md-3 col-lg-3">
                                    <DynamicSelect
                                        placeholder={''}
                                        valuetext={cliente}
                                        label={'Selecione o cliente'}
                                        name={'idCliente'}
                                        options={clientList}
                                        keyValue={'idCliente'}
                                        keyLabel={'cliente'}
                                        paramMethod={getCliente} clearOption={true} />
                                </div>
                                {/* <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 p-2">
                                    <DynamicInput type={'text'} placeholder={''} label={'Segurado'} name={'Segurado'} register={register} />
                                </div> */}
                                <div className="form-group col-sm-12 col-md-3 col-lg-3 header-select">
                                    <Multiselect
                                        className="searchWrapperCustom"
                                        placeholder={'Disciplinas'}
                                        showCheckbox="true"
                                        options={disciplinaList} // Options to display in the dropdown
                                        onSelect={onGetDisciplina} // Function will trigger on select event
                                        onRemove={onRemoveDisciplina} // Function will trigger on remove event
                                        displayValue="titulo" // Property name to display in the dropdown options
                                        showArrow={true}
                                    />
                                </div>
                               
                                {/* <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 p-2 header-select">
                                    <Multiselect
                                        className="searchWrapperCustom"
                                        placeholder={'Status TS'}
                                        showCheckbox="true"
                                        options={statusList} // Options to display in the dropdown
                                        onSelect={onGetStatus} // Function will trigger on select event
                                        onRemove={onRemoveStatus} // Function will trigger on remove event
                                        displayValue="value" // Property name to display in the dropdown options
                                        selectedValues={statusList.filter(status => idStatus.includes(status.id))}
                                        showArrow={true}
                                    />
                                </div>  */}                           

                                {/* <div className="row pt-2 d-flex flex-nowrap ">  */}
                                {/* <div className="position-relative col-sm-6 col-md-6 col-lg-6 pt-2"> */}
                                
                                <div className="form-group col-sm-4 col-md-6 col-lg-4">
                                    <DatePicker
                                        dateFormat="dd/MM/yyyy"
                                        locale="pt-BR"
                                        className="input-form w-100"
                                        selected={startDate}
                                        onChange={handleStartDateChange}
                                        placeholderText="Data de início do lançamento"
                                        customInput={<InputMask mask="99/99/9999" className="input-form py-2" style={{ width: '100%' }} />}
                                    />
                                </div>
                                <div className="form-group col-sm-4 col-md-6 col-lg-4">
                                    <DatePicker
                                        dateFormat="dd/MM/yyyy"
                                        locale="pt-BR"
                                        className="input-form w-100"
                                        selected={endDate}
                                        onChange={handleEndDateChange}
                                        placeholderText="Data fim do lançamento"
                                        customInput={<InputMask mask="99/99/9999" className="input-form py-2" style={{ width: '100%' }} />}
                                    />
                                </div>
                                <div className="form-group col-sm-4 col-md-6 col-lg-4">
                                    <DatePicker
                                        dateFormat="dd/MM/yyyy"
                                        locale="pt-BR"
                                        className="input-form w-100"
                                        selected={faturadoAte}
                                        onChange={handlefaturadoAteChange}
                                        placeholderText="Faturado até"
                                        customInput={<InputMask mask="99/99/9999" className="input-form py-2" style={{ width: '100%' }} />}
                                    />
                                </div>
                                <div className="col-sm-4 col-md-6 col-lg-4 mt-3">
                                    <input type="submit" className='default-button-red' value='Pesquisar' />
                                    {
                                        ListaData?.length > 0 && (<input type="button" className='default-button-red ml-3' value='Exportar' onClick={exportExcel} />)
                                    }
                                </div>
                            </div>

                       <br />
                       <StldRow>
                            <Flex>
                                <StyledForm style={{ width: "100%" }}>
                                    {isLoading ?
                                        <StldRow>
                                            <div className="text-center">
                                                <div className="align-items-center">
                                                    <div className="spinner-border ms-auto" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                                                    <div><strong style={{ color: "#EE4B21" }}>Pesquisando...</strong></div>
                                                </div>
                                            </div>
                                        </StldRow> : (
                                            <StyledTablePage>
                                           
                                            <div className="col-xs-6 col-sm-8 col-md-4 col-lg-5 col-xl-5" key={'filterTabs'}></div>                                                                                   
                                               {
                                              
                                                <Tabs className="timesheet m-0" selectedIndex={idEmpresaIndexTab ?? 2}>
                                                    <TabList>
                                                        {empresasUser?.length > 1 && (
                                                        <>
                                                            <Tab onClick={() => filtroEmpresa(1, 0)}>Critério Experts</Tab>
                                                            <Tab onClick={() => filtroEmpresa(2, 1)}>Adjusters</Tab>
                                                            <Tab onClick={() => filtroEmpresa(-1, 2)}>Todos</Tab>                                                         
                                                        </>
                                                        )}
                                                    </TabList>
                                                    
                                            
                                                    {ListaData && ListaData.length > 0 && (
                                                        <>
                                                    <TabPanel>                                             
                                                    <CardWipContabil TotaisData={TotaisData}ListaData={ListaData} />                                                
                                                    </TabPanel>

                                                    <TabPanel>
                                                    <CardWipContabil TotaisData={TotaisData} ListaData={ListaData}    />
                                                    </TabPanel>

                                                    <TabPanel>
                                                    <CardWipContabil TotaisData={TotaisData} ListaData={ListaData}    />
                                                    </TabPanel>
                                                    </>
                                                )}
                                                    </Tabs> 
                                                   
                                                                                                                                               
                                                    
                                                  }   


                                            </StyledTablePage>
                                        )
                                    }
                                </StyledForm>
                            </Flex>
                        </StldRow>
                        </StyledForm>
                        <br />                                    
                    </div>
                </StyledDefaultPage>
            </main>

        </section>
    );
};

export const WipContabilPage = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    return (
        <>
            {isMenuOpen ? (
                <MenuPage
                    isMenuOpen={isMenuOpen}
                    setIsMenuOpen={setIsMenuOpen}
                />
            ) : (
                <>
                    <Header
                        isMenuOpen={isMenuOpen}
                        setIsMenuOpen={setIsMenuOpen}
                    />
                    <WIPContabil />
                </>
            )}
        </>
    );
};
